import { render, staticRenderFns } from "./deptproperty.vue?vue&type=template&id=5c14c87a&"
import script from "./deptproperty.vue?vue&type=script&lang=js&"
export * from "./deptproperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports